// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","main":"App_main__5VZ13","main__qr-list":"App_main__qr-list__VS5vC","container":"App_container__4L7Vo","loader":"App_loader__IPVO6","spin":"App_spin__Lgf8x"};